// src/main-component/MobileMenu/MobileMenu.jsx
import React, { useEffect, useState, useCallback } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Collapse from "@mui/material/Collapse";
import { Link } from "react-router-dom";
import LanguageSwitcher from "../LanguageSwitcher";
import { useTranslation } from "react-i18next";

// i18nKey eklendi
const menus = [
  { id: 1, i18nKey: "menu_home", link: "/home" },
  { id: 2, i18nKey: "menu_about", link: "/about" },
  { id: 3, i18nKey: "menu_events", link: "/events" },
  { id: 4, i18nKey: "menu_announcements", link: "/announcements" },
  { id: 5, i18nKey: "menu_blog", link: "/blog" },
  { id: 6, i18nKey: "menu_contact", link: "/contact" },
];

const MobileMenu = ({ open = false, onClose = () => {} }) => {
  const { t } = useTranslation();
  const [openId, setOpenId] = useState(null);

  const toggle = (id) => setOpenId((prev) => (prev === id ? null : id));
  const handleLink = useCallback(() => { window.scrollTo(10, 0); onClose(); }, [onClose]);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    const onKey = (e) => e.key === "Escape" && onClose();
    if (open) window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [open, onClose]);

  return (
    <>
      <div className={`mobile-menu-overlay ${open ? "is-open" : ""}`} onClick={onClose} aria-hidden={!open} />
      <aside role="dialog" aria-modal="true" aria-labelledby="mobile-menu-title"
             className={`mobile-menu-panel ${open ? "is-open" : ""}`} onClick={(e) => e.stopPropagation()}>
        <div className="mobile-menu-header">
          <h2 id="mobile-menu-title">Menü</h2>
          <button className="mobile-menu-close" aria-label="Close" onClick={onClose}>×</button>
        </div>

        <div className="mobile-menu-lang">
          <LanguageSwitcher /> {/* TR / EN butonların zaten burada */}
        </div>

        <ul className="main_menu_list">
          {menus.map((item) => (
            <li className={item.id === openId ? "active" : ""} key={item.id}>
              {item.submenu ? (
                <>
                  <button className="menu-parent" onClick={() => toggle(item.id)}
                          aria-expanded={item.id === openId} aria-controls={`submenu-${item.id}`}>
                    {t(item.i18nKey)}
                    <span className="menu-parent__icon">{item.id === openId ? "−" : "+"}</span>
                  </button>
                  <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                    <List className="subMenu" id={`submenu-${item.id}`}>
                      {item.submenu.map((sub) => (
                        <ListItem key={sub.id} disableGutters>
                          <Link onClick={handleLink} to={sub.link}>
                            {sub.title}
                          </Link>
                        </ListItem>
                      ))}
                    </List>
                  </Collapse>
                </>
              ) : (
                <Link className="menu-leaf" to={item.link} onClick={handleLink}>
                  {t(item.i18nKey)}
                </Link>
              )}
            </li>
          ))}
        </ul>
      </aside>
    </>
  );
};

export default MobileMenu;
